import React from 'react'
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination } from '@mui/material';

const columns = [
    { id: 'project_name', label: 'Project Name'},
    { id: 'file_name', label: 'File Name'},
    { id: 'added_at', label: 'Date Added'},
    { id: 'updated_at', label: 'Last Updated'},
    { id: 'is_used', label: 'Status'},
    { id: 'actions', label: 'Actions',minWidth:150 },
];

const ProjectTable = ({ 
    page, 
    rowsPerPage, 
    tableData, 
    handleChangePage, 
    handleChangeRowsPerPage,
    handleEditProject,
    handleDeleteProject,
    handleCloseProject
}) => {
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer className='TableVirtuoso' sx={{ maxHeight: "100vh" }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData?.data?.length > 0 ? tableData?.data.map((row,i) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                    {columns?.map((column) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {column?.format && typeof value === 'number'
                                                    ? column.format(value) 
                                                    : column.id === 'actions' ? 
                                                    <>  
                                                        <IconButton 
                                                            color="inherit" 
                                                            title="Edit Project"
                                                            onClick={() => handleEditProject(row.id)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton 
                                                            color="error" 
                                                            title="Delete Project"
                                                            onClick={() => handleDeleteProject(row.id)}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                        {row['is_used'] === 1 &&
                                                            <IconButton 
                                                                color="inherit" 
                                                                title="Close Project"
                                                                onClick={() => handleCloseProject(row.id)}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        }
                                                    </>
                                                    : column.id === 'is_used' ? row['is_used'] === 0 ? 'Not Editing'  : 'Editing' : value
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            {tableData?.total > 0  ? 
                <TablePagination
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    component="div"
                    count={tableData?.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage} 
                />
                : <></>
            }
        </Paper> 
    )
}

export default ProjectTable